(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-hero-rewind"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-hero-rewind.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-ingredient-focus"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-ingredient-focus.js - do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-marquee"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-marquee.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-photo-scroll"] && !Shopify.designMode) return;
  try {
    
  /* JS lives in assets/wm-photo-scroll.js — do not write scripts here */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-section"] && !Shopify.designMode) return;
  try {
    
  /* No JS for this section */

  } catch(e) { console.error(e); }
})();
})();
